import React, {  } from 'react';
import { Input } from 'antd';
import { useSelector } from 'react-redux';
import { generateClassName } from 'jzfz-web-utils';
import { SearchOutlined } from '@ant-design/icons';
import { getQueryParams } from '../../util/common';

import './style/index.less';


/**
 * 搜索结果页
 */
const Search = () => {

    const { value } = getQueryParams();

    const { isMobile } = useSelector((state: any) => state.reducer);


    return (
        <div 
            className={generateClassName([
                "search-result-wrapper",
                isMobile ? "ptb20 plr16" : "ptb80 plr60"
            ])}
        >
            <div className="search-row flexjs flexic" style={{width: isMobile ? "100%" : "50%"}}>
                <Input defaultValue={value} />
                <SearchOutlined className="f24 ml5" />
            </div>
            <div className="search-content" style={{minHeight: 480}}>
                <span className="f12" style={{color: '#ddd'}}>搜索结果如下：</span>
            </div>
        </div>
    );
};

export { Search };